import {useQuery} from '@tanstack/react-query'
import {getPromotionDetail} from '@/services/promotionListService'
import {decodePromotionUrl} from '@/utils/urlUtils'

export function usePromotionDetail(id) {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['PROMOTION_DETAIL', id],
    queryFn: () => getPromotionDetail(id),
    enabled: !!id,
    select: (response) => {
      // Ensure we're working with a deep copy to prevent cache mutations
      const newResponse = JSON.parse(JSON.stringify(response));

      // Decode the URL if it exists
      if (newResponse?.data?.[0]?.bannerUrl) {
        newResponse.data[0].bannerUrl = decodePromotionUrl(newResponse.data[0].bannerUrl);
      }

      return newResponse;
    }
  })

  return {
    promotionData: data?.data?.[0],
    isLoading,
    isError,
    error
  }
}
